// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_o9j","cls2":"ReportList-cls2_KyD ReportList-cls1_o9j"};